import { useParams } from "react-router-dom";
import {
  useGetChainStoresInfiniteQuery,
  useCreateChainStoreMutation,
} from "../query/storesQuery";
import type { ChainId } from "@KassaroAB/shared/types/ids";
import { StoreListPage } from "./components/StoreListPage";

export const ChainStoresView = () => {
  const { chainId } = useParams<{ chainId: string }>();
  const { data: storesData, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetChainStoresInfiniteQuery(chainId);
  const { mutateAsync: createStore, isPending: createLoading } = useCreateChainStoreMutation(chainId);
  const allStores = storesData?.pages.flatMap((page) => page) ?? [];

  return (
    <StoreListPage
      allStores={allStores}
      isLoading={isLoading}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage ?? false}
      isFetchingNextPage={isFetchingNextPage}
      searchChainId={chainId as ChainId | undefined}
      onCreateStore={(data) => createStore(data)}
      createLoading={createLoading}
    />
  );
};
